import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  toFixed,
  format_date,
  Pagination,
  GET,
  loading,
  params,
  Navbar,
  XLSX,
  saveAs,
  DateRangePicker,
  BtnIcon
} from "../../components/CustomComponent.js";
import { report_invoice, report_tax_withholding } from "../../components/Report.js";
export default class Settlements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year_month: format_date(new Date(), "yyyy-mm","en"),
      loaded: false,
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }
  Get = async (page) => {
    const { year_month } = this.state;
    loading(true);
    let result = await GET("v1/admin/invoices", { page: page, data_search: "", year_month: year_month });
    if (result?.status) {
      this.setState({
        data: result.data,
        count: result.count,
        loaded: true,
      });
    }
  
    loading(false);
  };
  render() {
    const { data, count, year_month, loaded } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Broker</div>
                <h2 className="ar-title mb-1">Invoice Reports</h2>
                <div className="ar-subtitle">
                  invoice reports for tax withholding and invoice details
                </div>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Month</span>
                <input
                  type="month"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      year_month: e.target.value
                    });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={year_month}
                />
                </div>
                <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        year_month: format_date(new Date(), "yyyy-mm", "en"),
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
                </div>
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf571"}</span>
                  Invoices
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap">Date</td>
                    <td className="text-nowrap text-center wpx-140">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      <td data-label="Name" className="text-nowrap">{format_date(item.date,"dd/mm/yyyy","en")}</td>
                      <td data-label="Actions" className="text-center td-actions align-middle">
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`invoices-actions-${index}`}>Action</Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item data-testid="btn-report-withholding-tax" className="pu-action-item" onClick={async () => { report_tax_withholding(item); }}>
                              <span className="icon">{"\uf019"}</span>Withholding Tax PDF
                            </Dropdown.Item>
                            <Dropdown.Item data-testid="btn-report-invoice" className="pu-action-item" onClick={async () => { report_invoice(item); }}>
                              <span className="icon">{"\uf1c1"}</span>Invoice PDF
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td colSpan={2} className="text-center py-5">
                        <div className="ar-empty">No data</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
           
        </div>
      </div>
    );
  }
}
